import { NusrifAnimatedLogo } from "../ui/NusrifAnimatedLogo";

export function SplashScreen() {
  return (
    <div className="flex items-center justify-center h-screen bg-white">
      <div>
        <NusrifAnimatedLogo />
      </div>
    </div>
  );
}
